import * as Sentry from '@sentry/astro';
import { getSentryDsn } from './src/utils/sentry';

Sentry.init({
	dsn: getSentryDsn(),
	integrations: [Sentry.browserTracingIntegration()],
	tracesSampleRate: 0.1,
});
